export { default } from './HeroContent';
